export enum RenderErrorBoundaryHeight {
  Adapt = 'Adapt',
  Fullscreen = 'Fullscreen',
  FullPage = 'FullPage',
}
